
import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Tooltip from '@material-ui/core/Tooltip';
import styled, { css } from 'styled-components';
import { yellow } from '@material-ui/core/colors';
import { useNavbarCollapsed } from 'components/Dashboard/State';


const StyledMenuList = styled(MenuList)`
  margin: 0 15px;
  padding-top: 0;
  
  a {
    text-decoration: none;
    color: #111;
  }
  
  ${props => props.$collapsed && css`
    margin: 0 4px;
  `}
`;

const StyledMenuItem = styled(({ isLast, $collapsed, ...props }) => <MenuItem {...props} />)`
  color: #111;
  height: 48px;
  font-size: 16px !important;
  border: 1px solid #fff;
  margin-bottom: 8px;
  display: grid;
  grid-template-columns: 30px 1fr auto;
  padding: 0 11px;

  ${props => props.$collapsed && css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 4px;
    height: 40px;
    grid-template-columns: 1fr;

    .menu-item-label,
    .menu-item-chevron {
      display: none !important;
    }
    
    .MuiListItemIcon-root {
      justify-content: center;
      min-width: 0;
    }
  `}
  
  &.active {
    border-radius: 4px !important;
    border: 1px solid ${yellow[600]};
    
    .MuiSvgIcon-root {
      color: ${yellow[600]};
    }
  }
  
  &:hover {
    border-radius: 4px !important;
    text-decoration: none;
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 30px !important;
  
  .MuiSvgIcon-root {
    font-size: 22px !important;
    color: #333333;
  }
`;

const StyledListItemName = styled.span`
  text-align: left;
`;


function isUrlActive(pathname, url) {
  return pathname === url || pathname.startsWith(`${url}/`);
}

function buildMenuItems(items, pathname) {
  return items.map((item) => ({
    ...item,
    isActive: isUrlActive(pathname, item.url),
  }));
}

function AppMenu({ items }) {
  const location = useLocation();
  const { navbarCollapsed } = useNavbarCollapsed();
  const [menuItems, setMenuItems] = useState(() => buildMenuItems(items, location.pathname));

  useEffect(() => {
    setMenuItems(buildMenuItems(items, location.pathname));
  }, [items, location.pathname]);

  return (
    <StyledMenuList $collapsed={navbarCollapsed} component={'div'}>
      {menuItems.map((item, index) =>
        <div key={item.name}>
          <Tooltip
            title={item.name}
            placement="right"
            disableHoverListener={!navbarCollapsed}
            disableFocusListener={!navbarCollapsed}
            disableTouchListener={!navbarCollapsed}
          >
            <span style={{ display: 'block', width: '100%' }}>
              <StyledMenuItem
                component={Link}
                className={item.isActive ? 'active': ''}
                isLast={index + 1 === items.length}
                $collapsed={navbarCollapsed}
                to={item.url}
              >
                {item.icon && (
                  <StyledListItemIcon>
                    {item.icon}
                  </StyledListItemIcon>
                )}
                <StyledListItemName className="menu-item-label">{item.name}</StyledListItemName>
                {item.isActive ? <ArrowRightAltIcon className="menu-item-chevron" /> : undefined}
              </StyledMenuItem>
            </span>
          </Tooltip>
        </div>
      )}
    </StyledMenuList>
  );
}

export default AppMenu;
